export default __webpack_public_path__ + "static/media/assigneeIcon.83117bcc.svg";